import { render, staticRenderFns } from "./TableBodyTurns.vue?vue&type=template&id=ea35717a&scoped=true&"
import script from "./TableBodyTurns.vue?vue&type=script&lang=js&"
export * from "./TableBodyTurns.vue?vue&type=script&lang=js&"
import style0 from "./TableBodyTurns.vue?vue&type=style&index=0&id=ea35717a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea35717a",
  null
  
)

export default component.exports